import { getAuthToken } from "../utils/authStorage";

import API_BASE_URL from '../config/apiBaseUrl';

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const message = data?.message || data?.detail || "Erreur lors de la gestion des favoris.";
    throw new Error(message);
  }
  return data;
};

const favoriteFoodsService = {
  async listFavorites() {
    const response = await fetch(`${API_BASE_URL}/favorite-foods`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        Accept: "application/json",
      },
    });

    return parseResponse(response);
  },

  async saveFavorite({ name, brand = "", code = "" }) {
    const response = await fetch(`${API_BASE_URL}/favorite-foods`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        name,
        brand,
        code,
      }),
    });

    return parseResponse(response);
  },

  async deleteFavorite(favoriteId) {
    const response = await fetch(`${API_BASE_URL}/favorite-foods/${favoriteId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
        Accept: "application/json",
      },
    });

    if (response.status === 204) {
      return;
    }

    await parseResponse(response);
  },
};

export default favoriteFoodsService;
